
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>About </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm employee-sports">
    <div class="container">
        <div class="sec-title text-center">
            <h4> MANJUSHA KULKARNI <span > PATIL</span></h4>
            <p>Semi Classical Recital, Bhajan, Abhang & Cultural Recital</p>
        </div>
        <div class="row mt-5">
            <div class="col-lg-8">
                <div class=" text-justify">
                    <h2 class="head-lea">MANJUSHA KULKARNI PATIL <span class="small-sm"> 05 DECEMBER 2019</span></h2>
                    <p>Born in Sangli (a small town in Maharashtra), known for its origin to several music maestros.
                        Manjusha’s parents being great music lovers identified the inborn talent and encouraged Manjusha
                        for a career in music. She started her initial training from Pt. Chintubua Mhaiskar. Alongwith a
                        “Sangeet Visharad” from Akhil Bharatiy Gandharva Mahavidyalaya, Miraj - Manjusha acquired a
                        Bachelor’s degree in Hindi followed by a Master’s degree in Music with a Gold Medal to her
                        credit from Shivaji University, Kolhapur.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/manjusha-patil.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-lg-12">
                <p>She has been a consistent winner of many prestigious music competitions. During one such competition,
                    Late Sangeetacharya Pt. D.V. Kanebua of Ichalkaranji happened to see Manjusha singing and noticed
                    her rich potential, which proved to be a turning point in her career. Then being in the Gurukul
                    tradition under Pt. Kanebua, she was fortunate to absorb the authentic nuances of Agra and Gwalior
                    Gharana.</p>
                <p>She received further training from Late Pt. Narendra Kanekar, a senior disciple of Pt. Kanebua and
                    then also from Dr. Vikas Kashalkar. Currently Manjusha is honing her advanced skills under the able
                    guidance of Padmashree Gantapasvi Pt. Ulhas Kashalkar.</p>
                <p>Manjusha is gifted with a mellifluous voice which she has further enhanced by mastering sustenance of
                    swaras, aesthetic approach, creative thinking, perfection of sur & command on rhythmic aspects. With
                    purity in exposition of Raga, complex patterns of 'Taan' rendered with speed & clarity - Manjusha is
                    equally adept in Semi Classical Music like Thumri, Dadra, Abhang and Natya Sangeet. All these
                    elements constitute her delightful performances.</p>
                <p>Though as a truly dedicated musician, she is constantly in the quest of excellence through
                    perseverance but a rich portfolio of prestigious national and international concerts & the awards
                    bestowed on her are a clear testimony of Manjusha’s successful footsteps in the world of music.</p>

                <h6 class="fw-bold">Let’s meet you then.</h6>
                <p>Classical and Semi Classical Vocal</p>
                <p>Date: Thursday, 5<sup>th</sup> December 2019</p>
                <p>Time: 7.00 Pm</p>
                <p>Venue: Chitnavis Centre, Beside Hislop College, Civil Lines Nagpur.</p>
            </div>
        </div>
        <div class="border-line-sm"></div>

        <div class="row row-cols-1 row-cols-md-3">
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">MEDIA COVERAGE</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="media#media_classical" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">VIDEOS</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                YouTube link</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>

            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">PHOTOS</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="photogallery" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-2">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/manjusha-patil.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/manjusha-patil.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/manjusha-patil.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/manjusha-patil.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/manjusha-patil.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/manjusha-patil.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
